module.exports = __webpack_public_path__ + "img/hr-wooden-particle-15.cb7a7bf9.png";